var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58325 4.16675C6.58325 3.75253 6.24747 3.41675 5.83325 3.41675C5.41904 3.41675 5.08325 3.75253 5.08325 4.16675V8.33342C5.08325 9.6374 5.60126 10.888 6.52331 11.81C7.44536 12.7321 8.69594 13.2501 9.99992 13.2501C11.3039 13.2501 12.5545 12.7321 13.4765 11.81C14.3986 10.888 14.9166 9.6374 14.9166 8.33342V4.16675C14.9166 3.75253 14.5808 3.41675 14.1666 3.41675C13.7524 3.41675 13.4166 3.75253 13.4166 4.16675V8.33342C13.4166 9.23957 13.0566 10.1086 12.4159 10.7494C11.7751 11.3901 10.9061 11.7501 9.99992 11.7501C9.09376 11.7501 8.22472 11.3901 7.58397 10.7494C6.94322 10.1086 6.58325 9.23957 6.58325 8.33342V4.16675ZM4.16675 15.0836C3.75253 15.0836 3.41675 15.4194 3.41675 15.8336C3.41675 16.2478 3.75253 16.5836 4.16675 16.5836H15.8334C16.2476 16.5836 16.5834 16.2478 16.5834 15.8336C16.5834 15.4194 16.2476 15.0836 15.8334 15.0836H4.16675Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.3bd39c0b545cfb91a42b76820a366190.svg";
export { ForwardRef as ReactComponent };